import * as yup from 'yup';

export const schema = yup
  .object({
    emailAddressLabel: yup.string(),
    phoneNumberLabel: yup.string(),
    smsLabel: yup.string(),
    smsDisclaimer: yup.string(),
    termsText: yup.string(),
    termsUrl: yup.string(),
    privacyPolicyText: yup.string(),
    privacyPolicyUrl: yup.string(),
    submitButtonText: yup.string(),
    submitButtonVariant: yup.string(),
    loginPromptUrlText: yup.string(),
    loginPromptText: yup.string(),
    loginPromptUrl: yup.string(),
  })
  .transform(value =>
    value
      ? {
          emailAddressLabel: value.email_label,
          phoneNumberLabel: value.phone_number_label,
          smsLabel: value.sms_label,
          smsDisclaimer: value.sms_disclaimer,
          termsText: value.terms_text,
          termsUrl: value.terms_url,
          privacyPolicyText: value.privacy_policy_text,
          privacyPolicyUrl: value.privacy_policy_url,
          submitButtonText: value.submit_button_text,
          submitButtonVariant: value.submit_button_variant,
          loginPromptUrlText: value.login_prompt_url_text,
          loginPromptText: value.login_prompt_text,
          loginPromptUrl: value.login_prompt_url,
        }
      : {},
  );
